/**
 * Get the API base URL
 * Uses VITE_API_URL environment variable if set, otherwise falls back to relative /api path
 */
export function getApiUrl(path: string = ''): string {
  const apiUrl = import.meta.env.VITE_API_URL;

  if (apiUrl) {
    // Use explicit API URL (for production with separate API server)
    const base = apiUrl.replace(/\/$/, ''); // Remove trailing slash
    return path ? `${base}${path.startsWith('/') ? '' : '/'}${path}` : base;
  }

  // Fallback to relative path (for local development or same-domain deployment)
  const base = import.meta.env.BASE_URL?.replace(/\/$/, '') || '';
  const apiBase = `${base}/api`;
  return path ? `${apiBase}${path.startsWith('/') ? '' : '/'}${path}` : apiBase;
}
